import {roundF} from '../../../../util';
import {isEPCustomLike} from '../../../rendering/render.def';

export type OverallFrameSizeInput = {
    jfWidth: number;
    jfHeight: number;
    originalDocWidth: number;
    originalDocHeight: number;
    selectedDocWidth: number;
    selectedDocHeight: number;
    mouldingExteriorWidth: number;
    epId: number;
    epMethodId: number;
    epHeight: number;
};

export type OverallFrameSize = {
    width: number;
    height: number;
};

/** Plate height is added only for an active custom-like plate with a positive height. */
export function eligiblePlateHeightForOverallFrame(epId: number, epMethodId: number, epHeight: number): number {
    return epId > 0 && isEPCustomLike(epMethodId) && epHeight > 0 ? epHeight : 0;
}

export function getOverallFrameSize(input: OverallFrameSizeInput): OverallFrameSize {
    const plateHeight = eligiblePlateHeightForOverallFrame(input.epId, input.epMethodId, input.epHeight);
    return {
        width: roundF(input.jfWidth - input.originalDocWidth + input.selectedDocWidth + input.mouldingExteriorWidth * 2, 1),
        height: roundF(input.jfHeight - input.originalDocHeight + plateHeight + input.selectedDocHeight + input.mouldingExteriorWidth * 2, 1),
    };
}
